"use client";

import {
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  MultiSelect,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { getHotkeyHandler, useClipboard, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import {
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import { getProvinceSelectNew } from "../../../../service/getSelectApi";
import {
  ConfigDeliveryXfastModel,
  renderLabelXfast,
} from "./CreateConfigDeliveryXfast";

const EditConfigDeliveryXfast = ({
  data,
  onSuccess,
}: {
  data: any;
  onSuccess: any;
}) => {
  const clipboard = useClipboard({ timeout: 1000 });
  const [visible, { open, close }] = useDisclosure(false);
  const [dataProvinceSelectNew, setDataProvinceSelectNew] = useState<
    ComboboxItem[]
  >([]);
  const [dataCommuneSelectNew, setDataCommuneSelectNew] = useState<
    ComboboxItem[]
  >([]);
  const [att1Value, setAtt1Value] = useState<string | null>(data?.att1 ?? null);
  const [att3Value, setAtt3Value] = useState<string | null>(data?.att3 ?? null);

  const form = useForm<ConfigDeliveryXfastModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      code: data?.code ?? null,
      name: data?.name ?? null,
      att1: data?.att1 ?? null,
      att3: data?.att3 ?? null,
      attr16: "Khác",
    },

    validate: {
      code: (value: string | null) => {
        if (!value || value.length === 0) {
          return "Vui lòng nhập mã loại GV !";
        }
      },
      name: (value: string | null) => {
        if (!value || value.length === 0) {
          return "Vui lòng nhập tên loại GV !";
        }
      },
    },
  });

  const handlePasteValueCommune = async () => {
    const text = await navigator.clipboard.readText();

    const dataText = text + "," + (att3Value || "");

    const dataPaste = [
      ...new Set(
        dataText
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item !== ""),
      ),
    ];

    const dataCommune = dataCommuneSelectNew.map((item: any) => item.value);
    const dataFinal = dataPaste.filter((i) => dataCommune.includes(i));

    const newAtt3 = dataFinal.join(",");
    setAtt3Value(newAtt3);
    form.setValues((prev) => ({
      ...prev,
      att3: newAtt3,
    }));

    if (dataPaste.length !== dataFinal.length) {
      NotificationExtension.Info("Đã lọc bỏ các phường/xã không hợp lệ !");
    }
  };

  const fetchDataProvinceNew = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceSelectNew(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  const fetchDataCommuneNew = async (listId: string[]) => {
    const url = listId.map((i) => `ProvinceIds=${i}`).join("&");

    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDmCommuneMoi/get-select?active=true&" + url,
    );

    if (res && res.success) {
      const dataRes = res.data
        ?.filter((item: any) => item.text && item.value)
        ?.map((item: any) => ({
          value: String(item.value),
          label: String(item.text),
        }));
      setDataCommuneSelectNew(dataRes);

      if (att3Value && String(att3Value).length > 0) {
        const dataForm = String(att3Value).split(",");
        const dataNew = dataRes.map((item: any) => item.value);
        const dataSet = dataForm.filter((i) => dataNew.includes(i));

        const newAtt3 = dataSet.join(",");
        setAtt3Value(newAtt3);
        form.setValues((prev) => ({
          ...prev,
          att3: newAtt3,
        }));
      }
    }
  };

  const handleEditConfigDeliveryXfast = async (
    dataSubmit: ConfigDeliveryXfastModel,
  ) => {
    open();
    try {
      const dataFull = { ...data, ...dataSubmit };

      const res = await repositoryPos.put<MessageResponse<any>>(
        "/api/v1/WebsiteDelivery/update",
        dataFull,
      );

      if (res && res.success) {
        NotificationExtension.Success("Chỉnh sửa loại GV thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess(dataFull);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    fetchDataProvinceNew();
    if (att1Value && String(att1Value).length > 0) {
      fetchDataCommuneNew(String(att1Value).split(","));
    }
  }, []);

  const selectedProvinceValues =
    att1Value && String(att1Value).length > 0
      ? String(att1Value).split(",")
      : [];
  const isAllProvinceSelected =
    dataProvinceSelectNew.length > 0 &&
    selectedProvinceValues.length === dataProvinceSelectNew.length;

  const selectedCommuneValues =
    att3Value && String(att3Value).length > 0
      ? String(att3Value).split(",")
      : [];
  const isAllCommuneSelected =
    dataCommuneSelectNew.length > 0 &&
    selectedCommuneValues.length === dataCommuneSelectNew.length;

  return (
    <Box
      component="form"
      w={"50vw"}
      maw={700}
      pt={10}
      onSubmit={form.onSubmit((e: ConfigDeliveryXfastModel) =>
        handleEditConfigDeliveryXfast(e),
      )}
    >
      <Grid>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <TextInput
            key={form.key("code")}
            label={renderLabelXfast("Mã loại GV", "code", true)}
            placeholder="Nhập mã loại GV"
            variant="filled"
            readOnly
            {...form.getInputProps("code")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <TextInput
            key={form.key("name")}
            label={renderLabelXfast("Tên loại GV", "name", true)}
            placeholder="Nhập tên loại GV"
            {...form.getInputProps("name")}
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <MultiSelect
            label={renderLabelXfast("Tỉnh/TP áp dụng", "att1")}
            styles={{ input: { maxHeight: 110, overflowY: "auto" } }}
            placeholder="Nhập tỉnh/TP áp dụng"
            data={[{ label: "Tất cả", value: "ALL" }, ...dataProvinceSelectNew]}
            value={
              isAllProvinceSelected
                ? ["ALL", ...selectedProvinceValues]
                : selectedProvinceValues
            }
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            {...form.getInputProps("att1")}
            onChange={(e) => {
              const allProvinceValues = dataProvinceSelectNew.map(
                (item) => item.value,
              );
              const clickedAll = e.includes("ALL");

              let finalValues: string[];
              if (clickedAll && !isAllProvinceSelected) {
                // Chọn "Tất cả" -> chọn hết các tỉnh/TP
                finalValues = allProvinceValues;
              } else if (
                !clickedAll &&
                isAllProvinceSelected &&
                e.length === allProvinceValues.length
              ) {
                // Bỏ chọn "Tất cả" -> bỏ hết
                finalValues = [];
              } else {
                finalValues = e.filter((v) => v !== "ALL");
              }

              const newAtt1 =
                finalValues.length > 0 ? finalValues.join(",") : null;
              setAtt1Value(newAtt1);
              form.setValues((prev) => ({
                ...prev,
                att1: newAtt1,
              }));

              if (finalValues.length > 0) {
                fetchDataCommuneNew(finalValues);
              } else {
                setDataCommuneSelectNew([]);
                setAtt3Value(null);
                form.setValues((prev) => ({ ...prev, att3: null }));
              }
            }}
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <MultiSelect
            label={renderLabelXfast("Phường/xã nội thành", "att3")}
            styles={{ input: { maxHeight: 220, overflowY: "auto" } }}
            placeholder="Nhập phường/xã nội thành"
            data={[{ label: "Tất cả", value: "ALL" }, ...dataCommuneSelectNew]}
            disabled={!att1Value || String(att1Value).length === 0}
            rightSection={
              att3Value &&
              String(att3Value).length > 0 && (
                <Tooltip label={clipboard.copied ? "Đã sao chép" : "Sao chép"}>
                  <IconCopy
                    size={16}
                    color={clipboard.copied ? "#15aabf" : "gray"}
                    onClick={() => {
                      clipboard.copy(att3Value);
                    }}
                  />
                </Tooltip>
              )
            }
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            {...form.getInputProps("att3")}
            value={
              isAllCommuneSelected
                ? ["ALL", ...selectedCommuneValues]
                : selectedCommuneValues
            }
            onChange={(e) => {
              const allCommuneValues = dataCommuneSelectNew.map(
                (item) => item.value,
              );
              const clickedAll = e.includes("ALL");

              let finalValues: string[];
              if (clickedAll && !isAllCommuneSelected) {
                finalValues = allCommuneValues;
              } else if (
                !clickedAll &&
                isAllCommuneSelected &&
                e.length === allCommuneValues.length
              ) {
                finalValues = [];
              } else {
                finalValues = e.filter((v) => v !== "ALL");
              }

              const newAtt3 =
                finalValues.length > 0 ? finalValues.join(",") : null;
              setAtt3Value(newAtt3);
              form.setValues((prev) => ({
                ...prev,
                att3: newAtt3,
              }));
            }}
            onKeyDown={getHotkeyHandler([
              ["mod+V", handlePasteValueCommune],
              ["mod+C", () => clipboard.copy(att3Value)],
            ])}
          />
        </Grid.Col>
      </Grid>
      <Flex mt={10} justify={"end"} gap={"xs"}>
        <Button
          leftSection={<IconCheck size={16} />}
          color="green"
          type="submit"
          loading={visible}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default EditConfigDeliveryXfast;
